import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import AppContext from "../../../../services/app-context-services";
import { nicknameLimited, _c } from "../../../../services/text-services";
// @ts-ignore 
import { ChildInfo } from "../../../../models/home-rows";
import styles from "./login2.component.module.scss";
import Imagic from "../../../../components/imagic/imagic";
import Button from "../../../../components/button/button";
import golderStarImage from "../../../../../shared-assets/icons/star-golden.svg"
import whiteStarImage from "../../../../../shared-assets/icons/star-white.svg"
import Image from "next/image";

interface SelectChildStepProps {
  container: "page" | "modal";
  setClientId: (id: number) => void;
  isLoading: boolean;
  errorMessage?: string;
  childrenInfo: ChildInfo[];
}

function SelectChildStep({ setClientId, container, isLoading, errorMessage, childrenInfo }: SelectChildStepProps) {

  const [selectedId, setSelectedId] = useState(0);

  useEffect(() => {
    if (childrenInfo.length > 0) {
      setSelectedId(childrenInfo[0].id);
    }
  }, []);


  return (
    <div className={`container bg ${styles.wrapper} ${styles[container]}`}>
      <p className={_c(styles, "secondary-heading verification")}>
        برای ورود به دیجیتون یکی از پروفایل ها رو انتخاب کنید
      </p>
      <div className={_c(styles, "children-container")}>
        {childrenInfo.map(item => <div className={_c(styles, "child-item" + (selectedId === item.id ? " selected" : ""))}
          onClick={() => setSelectedId(item.id)}
        >

          <div className={_c(styles, "avatar-container")}>
            <div className={_c(styles, "circle")}/>
            <div className={_c(styles, "image-group")}>
              <Imagic height={70} width={70} src={item.avatar} />
              <Image src={selectedId === item.id ? golderStarImage : whiteStarImage} />
            </div>
          </div>

          <div className={_c(styles, "title" + (selectedId === item.id ? " selected" : ""))}>{nicknameLimited(item.nickname)}</div>
        </div>)}

      </div>
      <div className={_c(styles, `action-btn-container children-select ${styles[container]}`)}>
        <Button
          type="fill"
          size="fullWidth"
          text="ورود"
          disabled={!selectedId}
          customstyle={{
            boxShadow: "0px 4px 8px rgba(74, 87, 131, 0.16)",
            marginBottom: "60px"
          }}
          onClick={() => setClientId(selectedId)}
        />
      </div>
    </div>
  );
}

export default SelectChildStep;
